import { Close } from "@mui/icons-material";
import {styled, Dialog,DialogTitle,DialogContent, Typography, IconButton, TextField, Select, MenuItem, DialogActions, Button, FormControl, InputLabel, FormHelperText } from "@mui/material";
import React from "react";
import _ from 'lodash'
const StyledFormHelperText = styled(FormHelperText)({
 marginLeft:0
});
const StyledTextField = styled(TextField)({
  '& .MuiFormHelperText-root': {
marginLeft:0
  },
});
const StyledTypography = styled(Typography)({
  marginTop:2
})
const radiusData =()=>{
const last=5;
const arr=[]
for(let i=0.5;i<=last;i+=0.5){
    arr.push(i)

}

return arr;}

const LocalFalconSettings = ({open=false,handleClose,location={},formdata,setFormdata,onSave}) => {

  const handleChanges = (event) => {
    setFormdata(prev=>({ ...prev, [event.target.name]: event.target.value }));
  }
  // console.log(formdata)
  const onSaved=()=>{
if(onSave){
    onSave(formdata)
  }
  handleClose()}
    return<Dialog 
  open={open}
    onClose={handleClose}
    
    maxWidth="md"

  >
    <DialogTitle sx={{display:'flex', alignItems:'center',justifyContent:'space-between'}}>
        <Typography variant="h5">Settings</Typography>
        <IconButton onClick={handleClose}><Close/></IconButton>
    
    </DialogTitle>
    <DialogContent dividers>
    <div style={{display:'grid',gridTemplateColumns:'120px 1fr',gridGap:'16px',gridRowGap:'8px'}}>
        <Typography mt={1}>Keyword</Typography>
        <StyledTextField value={formdata?.keyword??''} helperText={'The desired search term or keyword.'}  onChange={handleChanges} fullWidth size="small" name="keyword"/>
        <Typography mt={1}>Latitude</Typography>
        <StyledTextField helperText={'The center point latitude value.'} value={formdata?.lat==0?"":formdata?.lat??''} onChange={handleChanges} fullWidth size="small" name='lat'/>
        <Typography mt={1}>Longitude</Typography>
        <StyledTextField helperText={'The center point longitude value.'} value={formdata?.lng==0?"":formdata?.lng??''} onChange={handleChanges} fullWidth size="small" name='lng'/>
        <Typography mt={1}>Grid size</Typography>
        <FormControl fullWidth size="small">
         
        <Select  value={formdata?.gridSize??''} onChange={handleChanges}fullWidth size="small" name='gridSize'>
            <MenuItem value={3}>3x3</MenuItem>
            <MenuItem value={5}>5x5</MenuItem>
        </Select>
        <StyledFormHelperText>The size of your desired grid.</StyledFormHelperText>
        </FormControl>
        <Typography mt={1}>Radius</Typography>
        <FormControl fullWidth size="small">
        <Select  value={formdata?.radius??''} onChange={handleChanges} fullWidth size="small" name='radius' MenuProps={{PaperProps:{sx:{height:'200px',overflowY:'auto'}}}}>
            {_.map(radiusData(),(radius)=>(
                <MenuItem value={radius}>{radius+'mi'}</MenuItem>
            ))}
        </Select>
        <StyledFormHelperText >The radius of your grid from center point to outer most north/east/south/west point.</StyledFormHelperText>
        </FormControl>



    </div>
    </DialogContent>
    <DialogActions sx={{justifyContent:'flex-start',alignItems:'center'}}>
        <Button variant="contained" color="primary" sx={{width:'120px'}} disabled={!formdata?.keyword}  onClick={onSaved}>Run Scan</Button>
        <Button variant='outlined' color='secondary' onClick={handleClose}>Close</Button>
</DialogActions>
  </Dialog>;
};

export default LocalFalconSettings;
